import {AfterViewInit, Component, Inject, OnInit, Renderer2} from '@angular/core';
import {HtmlUtilsService} from './html-utils/html-utils.service';
import {DOCUMENT} from '@angular/common';
import {AppConfigService} from "./config/app-config.service";
import {Router} from "@angular/router";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})

export class AppComponent implements OnInit, AfterViewInit {

  constructor(private htmlUtils: HtmlUtilsService,
              private renderer: Renderer2,
              private router: Router,
              private appConfig: AppConfigService,
              @Inject(DOCUMENT) document) {
    this.htmlUtils.renderer = renderer;
    this.htmlUtils.document = document;
    appConfig.loadConfig().then(() => router.initialNavigation());
  }

  public ngOnInit() {
    this.htmlUtils.ngOnInit();
  }

  ngAfterViewInit(): void {
    this.htmlUtils.ngAfterViewInit();
  }

}
